module.exports = __webpack_public_path__ + "static/media/plane-arrival.e7af8252.svg";